export default __webpack_public_path__ + "static/media/gulp.fa7e4784.svg";